
import _forEach from 'lodash/forEach'
import vSelect from "vue-select";
import track from "../../../components/track";

const form = new Vue({
    el: '#energia_empreses_form',

    components: {
        vSelect
    },

    data() {
        return {
            form: {
                name: '',
                phone: '',
                companyName: '',
                terms: false,
            },
            default: {
                name: '',
                phone: '',
                companyName: '',
                terms: false,
            },
            validation: {
                name: 'required',
                phone: 'required',
                companyName: 'required',
            },
            errors: {
                name: false,
                phone: false,
                companyName: false,
                terms: false,
            },
            requestStatus: 'unsent',
        }
    },
    methods: {
        validateInputs() {
            let hasErrors = false;
            _forEach(this.validation, (field, key) => {
                this.errors[key] = false
                if(key === 'phone'){
                    var phoneRGEX = /^[0-9]{9}$/;
                    var phoneResult = phoneRGEX.test(this.form[key]);
                    if(!phoneResult){
                        this.errors[key] = true;
                        hasErrors = true
                    }
                }

                if(key === 'name'){
                    if(!this.form[key].length){
                        this.errors[key] = true
                        hasErrors = true
                    }
                }

            })
            this.errors.terms = false
            if(!this.form.terms){
                console.log('error terms');
                this.errors.terms = true
                hasErrors = true
            }

            if(hasErrors)
                return false

            return true
        },

        clearForm() {
            this.form = Object.assign(this.form, this.default);
        },

        async submit(){
            if(!this.validateInputs()){
                return false
            }
            if (this.requestStatus == 'unsent') {
                this.requestStatus = 'sending'
                let params = {
                    name: this.form.name + ' ; ' + this.form.companyName,
                    phone: this.form.phone,
                    terms: this.form.terms,
                    meta: 'info',
                }
                track.event({
                    eventCategory: "B2B",
                    eventAction: "callmeback-B2B-info",
                    eventLabel: ""
                })
                axios.post('/empreses-energia/landing', params)
                    .then(response => {
                        if (response.data.status == 'success') {
                            this.requestStatus = 'sent'
                            this.clearForm()
                        } else {
                            console.log(response)
                        }
                    })
                    .catch(error => {
                        this.requestStatus = 'error'
                        console.log(error)
                    })
                    .then(() => {
                        setTimeout(() => {
                            this.requestStatus = 'unsent'
                        }, 8000)
                    })
            }
        },

        async submit2(){
            if(!this.validateInputs()){
                return false
            }
            let params = {
                name: this.form.name + ' ; ' + this.form.companyName,
                phone: this.form.phone,
                terms: this.form.terms,
                meta: 'call',
            }
            track.event({
                eventCategory: "B2B",
                eventAction: "callmeback-B2B-autoconsum",
                eventLabel: ""
            })
            axios.post('/empreses-energia/landing', params)
                .then(response => {
                    if (response.data.status == 'success') {
                        this.requestStatus = 'sent'
                        this.clearForm()
                    } else {
                        console.log(response)
                    }
                })
                .catch(error => {
                    this.requestStatus = 'error'
                    console.log(error)
                })
                .then(() => {
                    setTimeout(() => {
                        this.requestStatus = 'unsent'
                    }, 8000)
                })
        }
    },
    watch: {

    },
});

